namespace Ir.Components.Workbook.Widgets.FilterWidget {
    interface IViewModel {
        config: WorkbookConfig;
        widget: any;

        computedValuesSelectedTitleText: KnockoutComputed<string>;
        dropDownOptions: DevExpress.ui.dxDropDownBox.Properties;
        dropDownComponent: DevExpress.ui.dxDropDownBox;
        gridComponent: DevExpress.ui.dxDataGrid;
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        this.config = params.config as WorkbookConfig;
        this.widget = params.widget;

        let widget: FilterWidget = params.widget;
        widget.set$ReportContent(componentInfo.element);
        widget.setup();

        let config = widget.itemConfig;
        let self = this;
        this.computedValuesSelectedTitleText = ko.computed(function () {
            widget.calculateHeightFilter();
            if (config.condition() === FilterWidgetConditionEnum.MultipleSelection && config.editorType() === FilterWidgetEditorTypeEnum.List) {
                return`${widget.result.valuesSelectedTitleText()}`;
            }

            return "";
        });

        this.dropDownOptions = {
            value: widget.result.filter.multipleCondition,
            valueExpr: "0",
            placeholder: "Select a value...",
            displayExpr: ko.computed(function () {
                return config.displayField() ? "1" : "0"
            }),
            displayValueFormatter: function (value) {
                let dataSource = widget.result?.dataTable;
                let selected = widget.result?.filter?.multipleCondition?.() ?? value;
                if (Array.isArray(selected) && Array.isArray(dataSource) && dataSource.length > 0) {
                    if (selected.length === dataSource.length || selected.length === 0) {
                        return "All";
                    }

                    if (selected.length > 1) {
                        return `${selected.length}/${dataSource.length}`;
                    }

                    if (selected.length === 1 && selected[0] === null) {
                        return irSettings.nullText;
                    }
                }

                selected = value;
                if (Array.isArray(selected) && selected.length == 1) {
                    selected[0] = replaceBasicHtmlContent(selected[0]);
                }
                else if (typeof selected === "string") {
                    selected = replaceBasicHtmlContent(selected);
                }

                return selected as any;
            },
            showClearButton: true,
            dropDownOptions: {
                minWidth: 300
            },
            dataSource: widget.result.dataTable,
            contentTemplate(e) {
                let selectedValues = e.component.option("value");
                let div = $("<div>") as any;
                div.addClass("filter-widget-dropdown-grid");
                let gridComponent: DevExpress.ui.dxDataGrid;
                let $dataGrid = div.dxDataGrid({
                    dataSource: e.component.option("dataSource"),
                    keyExpr: e.component.option("valueExpr"),
                    columns: [
                        {
                            dataField: "0",
                            caption: MappingService.getFieldName(config.boundField()),
                            visible: config.boundFieldVisible(),
                            encodeHtml: false,
                            calculateDisplayValue: function (rowData) { 
                                let value = rowData[0];
                                if (value === null) {
                                    value = irSettings.nullText
                                }

                                return value;
                            }
                        },
                        {
                            dataField: "1",
                            caption: MappingService.getFieldName(config.displayField()),
                            visible: config.displayField() && ((config.boundField() === config.displayField() && !config.boundFieldVisible()) || config.boundField() !== config.displayField()),
                            encodeHtml: false,
                        }
                    ],
                    hoverStateEnabled: true,
                    searchPanel: {
                        visible: true,
                        placeholder: "Search..."
                    },
                    scrolling: { mode: "virtual" },
                    height: 250,
                    selection: {
                        mode: config.condition() === FilterWidgetConditionEnum.MultipleSelection ? "multiple" : "single",
                        showCheckBoxesMode: "always"
                    },
                    selectedRowKeys: selectedValues,
                    onInitialized(e) {
                        gridComponent = e.component;
                        sortBySelectedRows(e.component);
                    },
                    onSelectionChanged(selectedItems) {
                        config.allValuesSelected(false);
                        let keys = selectedItems.selectedRowKeys;
                        if (!widget.compareArrays(config.values.listValues(), keys)) {
                            if (config.condition() === FilterWidgetConditionEnum.MultipleSelection && widget.result.dataTable?.length
                                && widget.result.dataTable.length === keys.length) {
                                config.allValuesSelected(true);
                            }
                            
                            config.values.listValues(keys.slice());
                            widget.publishValues(true, true);

                            if (config.condition() === FilterWidgetConditionEnum.SingleSelection) {
                                e.component.close();
                            }

                            e.component.option("value", keys);
                        }
                    },
                    onRowClick(e) {
                        if (config.condition() === FilterWidgetConditionEnum.MultipleSelection) {
                            if (e.component.isRowSelected(e.key)) {
                                e.component.deselectRows([e.key]);
                            }
                            else {
                                e.component.selectRows([e.key], true);
                            }
                        }
                    },
                    toolbar: {
                        items: [
                            {
                                name: "searchPanel",
                                location: 'after',
                            }, {
                                location: 'after',
                                widget: 'dxButton',
                                options: {
                                    icon: 'clearformat',
                                    hint: 'Clear selected values',
                                    onClick() {
                                        if (widget.result.filter.filterEditorType() === FilterEditorTypeEnum.ValuesCombo) {
                                            widget.result.filter.startCondition("");
                                            widget.result.filter.multipleCondition([]);
                                        }
                                        else {
                                            widget.result.filter.multipleCondition([]);
                                        }

                                        gridComponent.clearSelection();
                                        sortBySelectedRows(gridComponent);

                                        widget.result.filter.publish();                                        
                                    },
                                },
                            }, {
                                location: 'after',
                                widget: 'dxButtonGroup',
                                visible: widget.itemConfig.showNullButton(),
                                options: {
                                    items: [{
                                        icon: 'ms ir-null-icon',
                                        id: null,
                                        hint: 'Include null value in options',
                                    } as any],
                                    keyExpr: 'id',
                                    stylingMode: 'outlined',
                                    selectedItemKeys: ko.computed(() => {
                                        let data = widget.result.filter.dataSource();
                                        if (data && data.find(x => x[0] === null)) {
                                            return [null]
                                        }
                                        return [];
                                    }) as any,
                                    onItemClick() {
                                        let data = widget.result.dataTable as any;
                                        if (data.find(x => x[0] === null)) {
                                            if (!FilterService.hasNullEntries(widget.result.filter.multipleCondition())) {
                                                widget.result.dataTable = [...data.filter(x => x[0] !== null)];
                                            }
                                        }
                                        else {
                                            widget.result.dataTable = ([[null, irSettings.nullText as any] as any, ...widget.result.dataTable]);
                                        }

                                        widget.result.filter.dataSource(widget.result.dataTable);                                        
                                        self.dropDownComponent.option("dataSource", widget.result.dataTable);
                                        gridComponent.option("dataSource", widget.result.dataTable);

                                        gridComponent.element().focus();
                                    }
                                }
                            }
                        ],
                    }
                });

                e.component.option("onOpened", function (e) {
                    $(".dx-toolbar-after", div).css({ 'width': '100%', 'padding-left': '0px' });
                    $(".dx-datagrid-search-panel", div).css({ 'width': '100%', 'margin-left': '0px' });
                });

                return $dataGrid;
            },
            onValueChanged(e) {
                var value = e.value;
                if (self.gridComponent) {
                    //self.gridComponent.selectRows(value, false);
                }
                else {
                //    if (vm.saveValueChanged && !compareArrays(vm.config.values.listValues(), e.value)) {
                //        if (vm.saveValueChanged) {
                //            publishValues(vm, true, true, false);
                //        }
                //    }
                }
            },
            onInitialized(e) {
                self.dropDownComponent = e.component;
            },
            onContentReady(e) {
                
                if (widget.result?.filter?.onContentReady) {
                    widget.result.filter.onContentReady();
                }
            }
        };
    }

    var sortBySelectedRows = function (dataGrid) {
        dataGrid.clearSorting();
        let columns = dataGrid.option("columns");
        let data = dataGrid.option("dataSource") ?? [];
        let selectedRowKeys = dataGrid.option("selectedRowKeys");
        data.sort(function (a, b) {
            let valA = a[columns[0].dataField];
            let valB = b[columns[0].dataField];
            let valASelected = false;
            let valBSelected = false;
            if (selectedRowKeys) {
                if (selectedRowKeys.includes(valA)) {
                    valASelected = true;
                }

                if (selectedRowKeys.includes(valB)) {
                    valBSelected = true;
                }
            }

            if ((valASelected && valBSelected) || (!valASelected && !valBSelected)) {
                if (valA < valB) {
                    return -1;
                }
                if (valA > valB) {
                    return 1;
                }

                return 0;
            }
            else if (valASelected) {
                return -1;
            }
            else {
                return 1;
            }
        });
        
        dataGrid.option("dataSource", data);
    }
}